import React from "react";
import { Result, Card, Typography, Button } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";

const { Text, Title } = Typography;

const PaymentSuccess: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Optional: read session_id if you want to display it
  const queryParams = new URLSearchParams(location.search);
  const sessionId = queryParams.get("session_id");

  return (
    <Card style={{ maxWidth: 600, margin: "40px auto", textAlign: "center" }}>
      <Result
        icon={<CheckCircleOutlined style={{ color: "green" }} />}
        status="success"
        title="Payment Successful!"
        subTitle="Thank you for your payment. Your subscription is now active!"
      />

      {/* Optional: show session ID */}
      {sessionId && (
        <div style={{ marginTop: 20 }}>
          <Text strong>Transaction Reference:</Text>
          <br />
          <Text type="secondary">{sessionId}</Text>
        </div>
      )}

      <Button
        type="primary"
        style={{ marginTop: 25 }}
        onClick={() => navigate("/superadmin/create-network")}
      >
         Back
      </Button>
    </Card>
  );
};

export default PaymentSuccess;